import JSON5 from 'json5';

export const isLocalhost = (doc: Document): boolean => doc.location.origin.indexOf('http://localhost') === 0;

/**
 * Parses lax-JSON (trailing commas, comments) and
 * merges the result with optional defaults.
 *
 * – `raw` may be  `string | undefined | null`.
 * – `defaults` is   *partial*  – only the props you want to guarantee.
 * – Return type is  `T | null`  (unchanged), or `T` if defaults supplied.
 */
export function parseJson<T = unknown>(raw: string | undefined | null, defaults?: Partial<T>): T | null {
  try {
    if (!raw) throw new Error('empty payload');

    const parsed = JSON5.parse(raw) as T;

    // If defaults given → merge  (parsed wins on overlap)
    return defaults ? ({ ...defaults, ...parsed } as T) : parsed;
  } catch (e) {
    console.error('Invalid JSON payload:', e);
    // On failure, fall back to defaults or null
    return defaults ? ({ ...defaults } as T) : null;
  }
}
